import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/media";

interface NewsCardProps {
  item: NewsItem;
  layout?: "vertical" | "horizontal";
}

export default function NewsCard({ item, layout = "vertical" }: NewsCardProps) {
  if (layout === "horizontal") {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group flex gap-3 md:gap-4 rounded-lg border border-secondary-200 bg-background-50 p-3 transition-colors hover:border-accent-300 cursor-pointer"
      >
        <div className="w-28 h-20 md:w-40 md:h-28 shrink-0 overflow-hidden rounded-md bg-secondary-100">
          <img
            src={item.cover}
            alt={`${item.title} 资讯配图`}
            title={`${item.title} - 星空传媒影视资讯`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="min-w-0 flex flex-col">
          <span className="mb-1 inline-flex w-fit items-center rounded-md bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-700">
            {item.category}
          </span>
          <h3 className="line-clamp-2 text-sm md:text-base font-medium text-foreground-900 transition-colors group-hover:text-accent-600">
            {item.title}
          </h3>
          <p className="mt-1 hidden line-clamp-2 text-xs text-foreground-500 sm:block">
            {item.summary}
          </p>
          <span className="mt-auto pt-1 text-xs text-foreground-400">
            {item.date} · {item.source}
          </span>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-secondary-200 bg-background-50 transition-all hover:border-accent-300 cursor-pointer animate-fade-up"
    >
      <div className="w-full aspect-[16/9] overflow-hidden bg-secondary-100">
        <img
          src={item.cover}
          alt={`${item.title} 资讯配图`}
          title={`${item.title} - 星空传媒影视资讯`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col p-4">
        <span className="mb-2 inline-flex w-fit items-center rounded-md bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-700">
          {item.category}
        </span>
        <h3 className="line-clamp-2 text-base font-medium text-foreground-900 transition-colors group-hover:text-accent-600">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm text-foreground-500">
          {item.summary}
        </p>
        <span className="mt-auto pt-3 text-xs text-foreground-400">
          {item.date} · {item.source}
        </span>
      </div>
    </Link>
  );
}